<template>
    <div class="notfound" :class="{'error':error}">
        <div class="image">
            <img :src="logo" alt="Logo" />
        </div>
        <div class="info">
            <div class="number" v-if="error">404</div>
            <p v-if="error">很抱歉，您要訪問的頁面不存在!</p>
            <p v-if="error">您點擊進來的連結可能發生故障，或該頁面已被移除，</p>
            <p v-if="info">{{info}}</p>
            <p v-html="infoHTML"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "notfound",
    components: {},
    props: {
        info: {
            type: String
        },
        infoHTML: {
            type: String,
            default: '您可回至<a href="/">首頁</a>，繼續遊覽其他頁面，謝謝!'
        },
        error: {
            type: Boolean
        }
    },
    data() {
        return {
            logo: require("@/assets/notfound.png")
        };
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notfound {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 10px;
    background-color: #eee;
}
.notfound .image {
    font-size: 0;
    width: 200px;
    margin-right: 3%;
}
.notfound.error .image {
    width: 300px;
}
.notfound .image img {
    width: 100%;
}
.notfound .info {
    letter-spacing: 2px;
    line-height: 1.5;
}
.notfound .info .number {
    font-size: 120px;
    font-weight: 600;
    color: #666;
}
.notfound .info p {
    padding: 5px 0;
    color: #666;
}
.notfound .info >>> a {
    color: #ee8b59;
    padding: 0 5px;
}
@media screen and (max-width: 767px) {
    .notfound {
        padding: 30px 0;
    }
    .notfound .image {
        width: 40%;
        margin-right: 5%;
    }
    .notfound .info {
        width: 50%;
    }
    .notfound.error {
        padding: 30px 10px;
        flex-direction: column;
    }
    .notfound.error .image {
        width: 100%;
        margin: 0 auto;
    }
    .notfound.error .info {
        width: 100%;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/notfound/index.vue